import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { kakaoState } from "../../recoil/kakaoState";
import { authState } from "../../recoil/authState";
import { contractModalState } from "../../recoil/contractModalState";
import { checkAuthLevel, createConditionalMenuItems } from "./utils";
import KakaoChatItem from "./components/KakaoChatItem";
import ContractNavItem from "./components/ContractNavItem";
import LogListItem from "./components/LogListItem";

export default function useBottomNavData() {
  const [Kakao] = useRecoilState(kakaoState);
  const auth = useRecoilValue(authState);
  const setContractModalOpen = useSetRecoilState(contractModalState);
  const clubAdminLevel = auth?.user?.club_admin_level;
  const isNotSBS = checkAuthLevel.isNotSBS(clubAdminLevel);

  const bottomNavData = [
    {
      key: "common",
      name: "일반",
      child: [
        {
          key: "contract",
          name: <ContractNavItem />,
          isBtn: true,
          onClick: () => setContractModalOpen(true),
          child: [],
          isMenuItem: true,
        },
        // SBS일 때는 이용문의 숨김
        ...createConditionalMenuItems(isNotSBS, [
          {
            key: "chat",
            name: <KakaoChatItem />,
            isBtn: true,
            onClick: () => {
              Kakao.teeshot.chat();
            },
            child: [],
            isMenuItem: true,
          },
        ]),
        {
          key: "logList",
          name: <LogListItem />,
          child: [],
          requiresMasterAuth: true,
          isMenuItem: true,
        },
      ],
    },
  ];

  return bottomNavData;
}
